import { render } from "./CardOrderStatus.vue?vue&type=template&id=01858757"
import script from "./CardOrderStatus.vue?vue&type=script&lang=js"
export * from "./CardOrderStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__